// Country
export const COUNTRY_US = Object.freeze({
  aliasSupported: true,
  countryCode: '1',
  currency: 'USD',
  flag: '🇺🇸',
  isoCode: 'US',
  name: 'United States',
  returnsFrom: true,
  shipsTo: true,
  sizeUnit: 'us',
  stateRequired: true,
  taxIncluded: false,
  zipRequired: true,
});

export const DEFAULT_COUNTRY_CODE = COUNTRY_US.isoCode;

// Currency
const CURRENCY_USD = Object.freeze({
  decimalMark: '.',
  disambiguatedSymbol: 'US$',
  hasNoCents: false,
  isoCode: 'USD',
  name: 'United States Dollar',
  rate: 1,
  symbol: '$',
  symbolFirst: true,
  thousandsSeparator: ',',
});

export const DEFAULT_CURRENCY_CODE = CURRENCY_USD.isoCode;

// Language
export const LANGUAGE_ENGLISH = Object.freeze({
  value: 'en',
  name: 'English',
});

export const LANGUAGE_FRENCH = Object.freeze({
  value: 'fr',
  name: 'French',
});

export const LANGUAGE_OPTIONS = [LANGUAGE_ENGLISH, LANGUAGE_FRENCH];

export const DEFAULT_LANGUAGE = { display: LANGUAGE_ENGLISH.name, value: LANGUAGE_ENGLISH.value };

// Cookie storage
export const STORAGE = {
  CURRENCY: 'currency',
  COUNTRY: 'country',
  CHECKOUT_ERROR: 'checkoutError',
  CHECKOUT_PLATFORM_COHORT: '_cp_cohort',
  FEATURE_FLAGS: 'featureFlags',
  COHORT_ASSIGNMENT: 'COHORT_ASSIGNMENT',
  LOCALE_OVERRIDE: 'localeOverride',
  LOCALE_REDIRECT: 'localeRedirect',
  LANGUAGE_LOCALE_REDIRECT: 'languageLocaleRedirect',
};
